import { Box, Button, Divider, Modal, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useHttp } from "../../hooks/useHttp";
import "./Landing.scss";
import { Login } from "../Login/Login";
import { useNavigate } from "react-router";

const report = require("../../images/report.png");
const image = require("../../images/image.png");
const background = require("../../images/background.png");

interface LandingInterface {
  authenticated: boolean;
  setAuthenticated: (authenticated: boolean) => void;
}

const partners = [
  {
    url: "",
    img: require("../../images/partners/report.png"),
  },
  {
    url: "",
    img: require("../../images/partners/mi2.png"),
  },
  {
    url: "",
    img: require("../../images/partners/pw.png"),
  },
  {
    url: "",
    img: require("../../images/partners/mini.png"),
  },
];

enum LandingLayoutMode {
  FULL,
  TABLET,
  MOBILE,
}

export const Landing = ({ authenticated, setAuthenticated }: LandingInterface) => {
  const navigate = useNavigate();
  const { trigger: checkLogin, loading: checkLoginLoading } = useHttp<Response>("/checkLogin", {}, true);

  const [loginModalOpen, setLoginModalOpen] = useState<boolean>(false);
  const [layoutMode, setLayoutMode] = useState<LandingLayoutMode>(
    window.innerWidth > 1300
      ? LandingLayoutMode.FULL
      : window.innerWidth > 1000
        ? LandingLayoutMode.TABLET
        : LandingLayoutMode.MOBILE,
  );

  useEffect(() => {
    const updateMobile = () => {
      if (window.innerWidth > 1300) setLayoutMode(LandingLayoutMode.FULL);
      else if (window.innerWidth > 1000) setLayoutMode(LandingLayoutMode.TABLET);
      else setLayoutMode(LandingLayoutMode.MOBILE);
    };

    window.addEventListener("resize", updateMobile);

    return () => window.removeEventListener("resize", updateMobile);
  }, []);

  useEffect(() => {
    checkLogin({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
      .then((response) => {
        if (response?.status === 200) {
          const sessionId = response.data;
          sessionStorage.setItem("authenticated", "true");
          sessionStorage.setItem("sessionId", sessionId);
          setAuthenticated(true);
        } else if (response?.status === 401) {
          sessionStorage.setItem("authenticated", "false");
          sessionStorage.setItem("sessionId", "");
          setAuthenticated(false);
        }
      })
      .catch(() => {
        sessionStorage.setItem("authenticated", "false");
        sessionStorage.setItem("sessionId", "");
        setAuthenticated(false);
      });
  }, []);

  return (
    <div className={"page landing"}>
      <Box
        className="landing-home"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="landing-home-info">
          <div
            className={
              layoutMode === LandingLayoutMode.FULL
                ? "landing-home-info-main"
                : "landing-home-info-main landing-home-info-main-center"
            }
          >
            <Typography variant={"h1"} className="landing-home-info-header">
              e<span className="text-highlight">X</span>plainable deep radiomics
            </Typography>
            <Typography variant={"subtitle1"} className="landing-home-info-description">
              Supporting Radiologists in Their Work
            </Typography>
            <div className="landing-home-info-buttons">
              {authenticated && <Button onClick={() => navigate("/tasks")}>Tasks</Button>}
              {!authenticated && <Button onClick={() => setLoginModalOpen(true)}>Login</Button>}
              <Button onClick={() => window.open("https://xlungs.mi2.ai/", "_blank")}>Read more</Button>
            </div>
          </div>
          {layoutMode === LandingLayoutMode.FULL && (
            <div className="landing-home-showcase">
              <div className="landing-home-showcase-item landing-home-showcase-image">
                <div className="landing-home-showcase-item-inline">
                  <img src={image} alt={"sample_image"} />
                </div>
              </div>
              <div className="landing-home-showcase-item landing-home-showcase-report">
                <div className="landing-home-showcase-item-inline">
                  <img src={report} alt={"report"} />
                </div>
              </div>
            </div>
          )}
        </div>
        <Box
          className="landing-home-partners"
          style={layoutMode === LandingLayoutMode.MOBILE ? { transform: "scale(1.2)" } : {}}
        >
          <Divider />
          <div className="landing-home-partners-images">
            {partners.map((partner, index) => (
              <img key={index} src={partner.img} alt={"partner"} onClick={() => (window.location.href = partner.url)} />
            ))}
          </div>
          {/*<Typography variant={"subtitle1"} className="landing-home-partners-subtitle">*/}
          {/*    Work on this project is financially supported by the <span>NCBiR</span>*/}
          {/*    grant <span>INFOSTRATEG-I/0022/2021-00</span>*/}
          {/*</Typography>*/}
        </Box>
      </Box>
      <Modal open={loginModalOpen} onClose={() => setLoginModalOpen(false)} className={"landing-login"}>
        <>
          <Login setAuthenticated={setAuthenticated} closeModal={() => setLoginModalOpen(false)} />
        </>
      </Modal>
    </div>
  );
};
